export default __webpack_public_path__ + "static/media/gallery_08.00a54573.jpg";